module.exports = __webpack_public_path__ + "img/kuaiji_zhizhao.0bbe909d.jpg";